export const productFields = [
  {
    label: "Name",
    key: "name",
    fieldType: {
      type: "input",
    },
    example: "Product Name",
    validations: [
      {
        rule: "required",
        errorMessage: "Name is required",
        level: "error",
      },
    ],
  },
  {
    label: "Price",
    key: "price",
    fieldType: {
      type: "input",
    },
    example: "123.45 (Note: Any non number will be replaced by 0)",
    validations: [
      {
        rule: "required",
        errorMessage: "Price is required",
        level: "error",
      },
      {
        rule: "numeric",
        errorMessage: "Price must be a numeric value",
        level: "error",
      },
    ],
  },
  {
    label: "Current Stock",
    key: "current_stock",
    fieldType: {
      type: "input",
    },
    example: "100",
    validations: [
      {
        rule: "required",
        errorMessage: "Current stock is required",
        level: "error",
      },
      {
        rule: "integer",
        errorMessage: "Current stock must be an integer",
        level: "error",
      },
    ],
  },
  {
    label: "Min Quantity",
    key: "min_quantity",
    fieldType: {
      type: "input",
    },
    example: "10",
    validations: [
      {
        rule: "required",
        errorMessage: "Min quantity is required",
        level: "error",
      },
      {
        rule: "integer",
        errorMessage: "Min quantity must be an integer",
        level: "error",
      },
    ],
  },
  {
    label: "Reduced Price",
    key: "reduced_price",
    fieldType: {
      type: "input",
    },
    example: "99.99 (Note: Any non number will be replaced by 0)",
    validations: [
      {
        rule: "numeric",
        errorMessage: "Reduced price must be a numeric value",
        level: "error",
      },
    ],
  },
  {
    label: "Description",
    key: "description",
    fieldType: {
      type: "textarea",
    },
    example: "Product Description",
    validations: [
      {
        rule: "string",
        errorMessage: "Description must be a string",
        level: "error",
      },
    ],
  },
  {
    label: "Bar Code",
    key: "bar_code",
    fieldType: {
      type: "input",
    },
    example: "1234567890",
    validations: [
      {
        rule: "string",
        errorMessage: "Bar code must be a string",
        level: "error",
      },
    ],
  },
  {
    label: "Category",
    key: "category",
    fieldType: {
      type: "input",
    },
    example: "Shirt",
    validations: [
      {
        rule: "string",
        errorMessage: "Category must be a string",
        level: "error",
      },
    ],
  },
  {
    label: "Highlight",
    key: "highlight",
    fieldType: {
      type: "checkbox",
    },
    example: "1 for true and 0 for false",
    validations: [
      {
        rule: "required",
        errorMessage: "Highlight is required",
        level: "error",
      },
      {
        rule: "boolean",
        errorMessage: "Highlight must be a boolean value",
        level: "error",
      },
    ],
  },
];

export const customerFields = [
  {
    label: "Name",
    key: "name",
    fieldType: {
      type: "input",
    },
    example: "Customer Name",
    validations: [
      {
        rule: "required",
        errorMessage: "Name is required",
        level: "error",
      },
    ],
  },
  {
    label: "Phone Number",
    key: "phone_number",
    fieldType: {
      type: "input",
    },
    example: "+977 9847012345",
    validations: [
      {
        rule: "required",
        errorMessage: "Phone Number is required",
        level: "error",
      },
    ],
  },
  {
    label: "Email",
    key: "email",
    fieldType: {
      type: "input",
    },
    example: "example@gmail.com",
  },
  {
    label: "Pay Later",
    key: "pay_later",
    fieldType: {
      type: "input",
    },
    example: "1 for true and 0 for false",
  },
  {
    label: "Address Line",
    key: "address_line",
    fieldType: {
      type: "input",
    },
    example: "Koteshwor - Narephat, Kathmandu",
  },
];
